import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { CreateProductInput } from "../../generated/graphql";
import ResponsiveDialog from "../common/ResponsiveDialog";
import AddProductModal from "../addProductModal/AddProductModal";
import { ItemSetup } from "../itemSetup/ItemSetup";

export default function AsynchronousSearchForProduct({
  showProductModal,
  onSelectProduct,
  selectProduct,
  setShowProductModal,
}: {
  showProductModal: boolean;
  onSelectProduct: Function;
  setShowProductModal: Function;
  selectProduct: CreateProductInput | undefined;
}) {
  const [createItemOpen, setCreateItemOpen] = useState(false);

  const handleKeyPress = (target: any) => {
    if (target.keyCode === 27) {
      setShowProductModal(false);
    }
  };

  const handleProductCreated = (createdProduct: any) => {
    setCreateItemOpen(false);
    if (onSelectProduct) {
      onSelectProduct(createdProduct);
    }
    setShowProductModal(false);
  };

  return (
    <>
      <ResponsiveDialog
        open={showProductModal}
        onClose={() => setShowProductModal(false)}
        title="Select Item"
        subtitle="Search and select an item, or create a new one"
        maxWidth="md"
        headerAction={
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<Add />}
            onClick={() => setCreateItemOpen(true)}
            sx={{
              minHeight: 36,
              px: { xs: 1.5, sm: 2 },
              fontSize: { xs: "0.75rem", sm: "0.85rem" },
              whiteSpace: "nowrap",
            }}
          >
            Create New Item
          </Button>
        }
        contentSx={{ p: { xs: 1, sm: 2 } }}
      >
        <Box onKeyDownCapture={handleKeyPress} sx={{ width: "100%", height: "100%" }}>
          <ItemSetup
            sortKey="name"
            onSelectProduct={(product: any) => {
              if (onSelectProduct) {
                onSelectProduct(product);
              }
              setShowProductModal(false);
            }}
            selectProduct={selectProduct}
          />
        </Box>
      </ResponsiveDialog>

      {/* Nested modal for creating a new product and auto-picking it */}
      <ResponsiveDialog
        open={createItemOpen}
        onClose={() => setCreateItemOpen(false)}
        title="Create New Item"
        subtitle="Add a new product to inventory"
        maxWidth="sm"
      >
        <AddProductModal
          isModal={true}
          onClose={() => setCreateItemOpen(false)}
          onSuccess={handleProductCreated}
        />
      </ResponsiveDialog>
    </>
  );
}
